import React, { useState } from "react";
import './NewExpenseForm.css';

function NewExpenseForm(props) {
const [enteredTitle, setEnteredTitle] = useState('');
const [enteredAmount, setEnteredAmount] = useState('');
const [enteredDate, setEnteredDate] = useState('');

const titleChangeHandler = (event) => {
  setEnteredTitle(event.target.value);
}

const amountChangeHandler = (event) => {
  setEnteredAmount(event.target.value);
}

const dateChangeHandler = (event) => {
  setEnteredDate(event.target.value);
}

const submitHandler = (event) => {
  event.preventDefault();
  
  const ExpenseData = {
    title : enteredTitle, 
    amount : +enteredAmount,
    date: new Date(enteredDate),
 };
    props.onsaveExpensedata(ExpenseData)
    setEnteredTitle('')
    setEnteredAmount('')
    setEnteredDate('')
};

return (
    <div>
      <form onSubmit={submitHandler}>
        <div className="new-expense__controls">
        <div className="new-expense__control">
        <label>Title</label>
        <input type="text" value={enteredTitle} onChange={titleChangeHandler}/>
        </div>
        <div className="new-expense__control">
        <label>Amount</label>
        <input type="number" min='0.1' step='0.1' value={enteredAmount} onChange={amountChangeHandler}/>
        </div>
        <div className="new-expense__control">
        <label>Date</label>
         <input type='date' min='01-01-2019' max='31-12-2022' value={enteredDate} onChange={dateChangeHandler}/>
        </div>
         </div>
        <div className="new-expense__actions">
        <button type="button" onClick={props.onClick}>Cancel</button>
          <button type="submit">Submit</button>
        </div>
      </form>
    </div>
  )
}

export default NewExpenseForm;